import { Separator, Skeleton } from "@/components/ui";
import { Fragment } from "react";

export const HospitalizationSkeleton = () => {
  return (
    <div
      className="flex flex-col gap-2 px-3 py-2"
      data-testid="hospitalization-skeleton"
    >
      {[...Array(3)].map((_, index) => (
        //  biome-ignore lint/suspicious/noArrayIndexKey: unneeded for loading skeleton
        <Fragment key={`hospitalization-skeleton-${index}`}>
          <div className="flex flex-row gap-4">
            <Skeleton className="h-12 w-1/2" />
            <Skeleton className="h-12 w-1/2" />
          </div>
          <Separator />
        </Fragment>
      ))}
    </div>
  );
};
